// Sans ordre explicite, les clés viennent du `jsonb` properties_schema, que
// Postgres trie par longueur puis octets : un classement que personne n'a voulu.

const pickPresent = (names, present, taken) => {
  const picked = []
  if (!Array.isArray(names)) return picked
  for (const name of names) {
    if (!present.has(name) || taken.has(name)) continue
    taken.add(name)
    picked.push(name)
  }
  return picked
}

export const orderAttributeKeys = (keys, order, { pinned } = {}) => {
  const source = Array.isArray(keys) ? keys : []
  const present = new Set(source)
  const taken = new Set()

  const head = pickPresent(pinned, present, taken)
  const ordered = pickPresent(order, present, taken)
  const rest = source.filter(k => !taken.has(k))

  return [...head, ...ordered, ...rest]
}
